import './SearchInput.css';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  className?: string;
  ariaLabel?: string;
}

/**
 * Full-width list-filter search field with magnifier icon and one-click clear
 * button. Visual design mirrors the Inbox search field (InboxPage).
 */
export default function SearchInput({
  value,
  onChange,
  placeholder,
  className,
  ariaLabel,
}: SearchInputProps) {
  return (
    <div className={`list-search${className ? ` ${className}` : ''}`}>
      <div className="list-search-wrapper">
        <svg className="list-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
        <input
          type="text"
          className="list-search-field"
          placeholder={placeholder}
          aria-label={ariaLabel || placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {value && (
          <button
            className="list-search-clear"
            onClick={() => onChange('')}
            aria-label="Clear search"
          >
            &times;
          </button>
        )}
      </div>
    </div>
  );
}
